import { jsx as e, jsxs as n } from "react/jsx-runtime";
import { tv as o } from "../tailwind-variants.config.js";
import { Switch as l } from "@headlessui/react";
import { LockIcon as i } from "../Common/LockIcon.js";
const c = o({
  slots: {
    switch: "jm-reset-translate jm-relative jm-h-6 jm-w-12 jm-rounded-full jm-border-none jm-p-0 jm-m-0",
    pill: "jm-block jm-h-4 jm-w-4 jm-transition-transform jm-transform jm-rounded-full jm-bg-white",
    label: "jm-text-jutro-new-warm-gray-800 jm-font-paragraph-1 jm-select-none"
  },
  variants: {
    isEnabled: {
      true: {
        switch: "jm-bg-jutro-new-blue-800",
        pill: "jm-translate-x-7"
      },
      false: {
        switch: "jm-bg-jutro-new-warm-gray-500",
        pill: "jm-translate-x-1"
      }
    },
    disabled: {
      true: {
        switch: "jm-cursor-default",
        label: "jm-text-jutro-new-warm-gray-500",
        pill: "jm-flex jm-items-center jm-justify-center"
      },
      false: {
        switch: "jm-cursor-pointer"
      }
    }
  },
  compoundVariants: [
    {
      isEnabled: !0,
      disabled: !0,
      class: {
        switch: "jm-bg-jutro-new-blue-400",
        pill: "jm-text-jutro-new-blue-400"
      }
    },
    {
      isEnabled: !1,
      disabled: !0,
      class: {
        switch: "jm-bg-jutro-new-warm-gray-200",
        pill: "jm-text-jutro-new-warm-gray-200"
      }
    }
  ]
}), d = ({
  label: m,
  disabled: t,
  isEnabled: s,
  setIsEnabled: a,
  ...j
}) => {
  const r = c({
    isEnabled: s,
    disabled: t
  });
  return /* @__PURE__ */ e(l.Group, { children: /* @__PURE__ */ n("div", { className: "jm-flex jm-items-center jm-gap-2", children: [
    /* @__PURE__ */ e(
      l,
      {
        ...j,
        checked: s,
        onChange: a,
        disabled: t,
        className: r.switch(),
        children: /* @__PURE__ */ e("span", { className: r.pill(), children: t ? /* @__PURE__ */ e(i, {}) : null })
      }
    ),
    m && /* @__PURE__ */ e(l.Label, { className: r.label(), children: m })
  ] }) });
};
export {
  d as Toggle
};
//# sourceMappingURL=index.js.map
